webpackJsonp([50739212244294],{

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(33);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tags = function Tags(_ref) {
	  var pathContext = _ref.pathContext;
	  var posts = pathContext.posts,
	      tagName = pathContext.tagName;
	
	
	  if (posts) {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'span',
	        null,
	        'Posts about ',
	        tagName,
	        ':'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        posts.map(function (post) {
	          return _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: post.frontmatter.path },
	              post.frontmatter.title
	            )
	          );
	        })
	      )
	    );
	  }
	};
	
	exports.default = Tags;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-tags-js-9f33bf6d5da76dc9fc95.js